exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-container {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n  z-index: 99999; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/notify/notify-container/notify-container.component.scss
// module id = ../../../../../src/app/notify/notify-container/notify-container.component.scss
// module chunks = main